module.exports = __webpack_public_path__ + "img/combo.17e7072d.png";